var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeToggleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 1C38.2 1 49 11.8 49 25C49 38.2 38.2 49 25 49C11.8 49 1 38.2 1 25C1 11.8 11.8 1 25 1ZM25 0C11.2 0 0 11.2 0 25C0 38.8 11.2 50 25 50C38.8 50 50 38.8 50 25C50 11.2 38.8 0 25 0ZM25.5 7V3C25.5 2.7 25.3 2.5 25 2.5C24.7 2.5 24.5 2.7 24.5 3V7C24.5 7.3 24.7 7.5 25 7.5C25.3 7.5 25.5 7.3 25.5 7ZM7.5 25C7.5 24.7 7.3 24.5 7 24.5H3C2.7 24.5 2.5 24.7 2.5 25C2.5 25.3 2.7 25.5 3 25.5H7C7.3 25.5 7.5 25.3 7.5 25ZM47.5 25C47.5 24.7 47.3 24.5 47 24.5H43C42.7 24.5 42.5 24.7 42.5 25C42.5 25.3 42.7 25.5 43 25.5H47C47.3 25.5 47.5 25.3 47.5 25ZM25.5 47V43C25.5 42.7 25.3 42.5 25 42.5C24.7 42.5 24.5 42.7 24.5 43V47C24.5 47.3 24.7 47.5 25 47.5C25.3 47.5 25.5 47.3 25.5 47Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeToggleWhite);
export default __webpack_public_path__ + "static/media/timeToggleWhite.08b4fcd41082ea1e8cab7d8ec4d00526.svg";
export { ForwardRef as ReactComponent };